import axios from "axios";
import { apiConfig } from "./config";
const { rootUrl, headers } = apiConfig;
const { CancelToken } = axios;

export const source = () => {
  return CancelToken.source();
};

export const isCancel = e => {
  return axios.isCancel(e);
};

export const get = (url, config) => {
  const requestUrl = `${rootUrl}api/${url}`;
  return axios.get(requestUrl, { headers, ...config });
};

export const post = (url, payload = null, cancelToken = null) => {
  const requestUrl = `${rootUrl}api/${url}`;
  return axios.post(
    requestUrl,
    payload === null ? null : JSON.stringify(payload),
    { headers, cancelToken }
  );
};

export const remove = url => {
  const requestUrl = `${rootUrl}api/${url}`;
  return axios.delete(requestUrl, { headers });
};



// WEBPACK FOOTER //
// ./src/api/method.js